import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import config from "@/lib/config";
class AreaCheckAPI {
  constructor() {
    let uid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "guest_web";
    _defineProperty(this, "url", config.areaCheck.url);
    _defineProperty(this, "apiKey", config.areaCheck.key);
    this.uid = uid;
  }
  async check(lat, lng) {
    // debug 広島の緯度経度
    // lat = 34.40458483926412;
    // lng = 132.45550318583173;
    const params = {
      api_key: this.apiKey,
      uid: this.uid,
      lat,
      lng
    };
    const qs = new URLSearchParams(params);
    return await fetch(`${this.url}?${qs}`).then(async res => ({
      ok: res.ok,
      json: await res.json()
    }));
  }
}
export default AreaCheckAPI;